import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import styles from './index.pcss';
import Image from '../../../atoms/ImageView';
import TopHeader from '../components/MilestoneHeader';
import AssuredGiftsHeaderText from '../../../atoms/AssuredGiftsHeaderText';
import HowItWorks from '../components/HowItWorksList';
import PartnerList from '../components/PartnersList';
import DesktopAccordion from './DesktopAccordion';
import Footer from '../components/Footer';
import { getAssuredFlags } from '../../../selectors/featureFlagsSelector';
import CommaFormatted from '../../../../modules/ajio-util/commify';

const cx = classNames.bind(styles);

interface DesktopAssuredGiftsLayoutProps {
  assuredFlagData: import('../../../types/firebaseFlags').AssuredGiftsLandingData;
  assuredGiftsData: import('../../../types/assuredGifts').AssuredGiftsData;
}

const mapStateToProps = (
  state: import('../../../types/rootState').RootState
): DesktopAssuredGiftsLayoutProps => {
  return {
    assuredFlagData: getAssuredFlags(state),
    assuredGiftsData: state?.assuredGifts?.data
  };
};

const connector = connect(mapStateToProps);

const DesktopAssuredGiftsLayout = (props: DesktopAssuredGiftsLayoutProps): JSX.Element => {
  const {
    assuredGiftsData: { orderValue = 0, gifts = [], ctaText = '' } = {},
    assuredFlagData: {
      giftMileStone: { header: mileStoneHeader = '', subHeader: mileStoneSubHeader = '' } = {},
      howItWorks: {
        header: howItWorksHeader = '',
        subHeader: howItWorksSubHeader = '',
        steps
      } = {},
      ourPartners: {
        header: outPartnerHeader = '',
        subHeader: ourPartnerSubHeader = '',
        partnerArr
      } = {},
      tncLink = '/help/termsAndCondition',
      orderAmount = '',
      shopAndWin = '',
      meetRequiredCriteria = ''
    } = {}
  } = props;
  return (
    <div className={cx('assured-landing-container')}>
      <div className={cx('assured-landing-head-container')}>
        <div className={cx('assured-landing-order-amount')}>
          <p>{`${orderAmount}${CommaFormatted(orderValue)}`}</p>
        </div>
        <div className={cx('assured-landing-head-content')}>
          <div className={cx('assured-landing-head-text-container')}>
            <p>{shopAndWin}</p>
            <p>{meetRequiredCriteria}</p>
          </div>
          <Image src="/img/assured-gift-box.svg" alt="Gift icon" className="gift-image" />
        </div>
      </div>
      <TopHeader header={mileStoneHeader} subHeader={mileStoneSubHeader} deviceType="desktop" />
      {ctaText && (
        <AssuredGiftsHeaderText
          text={ctaText}
          textAlign="center"
          width="medium"
          lineHeight="desktopLineHeight"
          alignDiv="center-align"
          variant="T4"
        />
      )}
      <div
        className={cx(
          'assureed-landing-accordion-container',
          !ctaText && 'assured-landing-accordion-condition-container'
        )}
      >
        <DesktopAccordion giftsData={gifts} />
      </div>
      <TopHeader header={howItWorksHeader} subHeader={howItWorksSubHeader} deviceType="desktop" />
      <HowItWorks howItWorks={steps} deviceType="desktop" />
      <TopHeader header={outPartnerHeader} subHeader={ourPartnerSubHeader} deviceType="desktop" />
      <PartnerList partnerArr={partnerArr} deviceType="desktop" />
      <Footer tncLink={tncLink} deviceType="desktop" />
    </div>
  );
};

export default connector(DesktopAssuredGiftsLayout);
